import { axios } from '@Root/API'

export const edit = (studyProgrammeId, courseRoleId, payload) => {
	return axios.post(`program/${studyProgrammeId}/course-role/${courseRoleId}`, payload)
}
